import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '../styles'

/**
 *
 * @param {number} size size icon
 * @param {string} color color hexadecimal
 * @returns {React.Component}
 */
const IcRemoveCircle = ({ size }) => {
  return (
    <Icon
      className="IcRemoveCircle material-icons tw-flex tw-items-center tw-justify-center tw-text-primary"
      size={size}
    >
      remove_circle_outline
    </Icon>
  )
}

IcRemoveCircle.propTypes = {
  size: PropTypes.number.isRequired
}

export default IcRemoveCircle
